const formatCampo = (value) => {
  const modalidades = {
    administracion: "Administración",
    ciencias_naturales_matematicas_y_estadistica: "Ciencias Naturales, Matemáticas y Estadística",
    salud_y_bienestar: "Salud y Bienestar",
    ingenieria_industria_y_construccion:"Ingeniería, Industria y Construcción",
  };

  if (modalidades[value]) return modalidades[value];

  // fallback automático
  return value
    ?.replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

const Campo = ({ value }) => {
  if (!value) return null;

  return (
    <>
     {formatCampo(value)}
    </>
  );
};

export default Campo;